import { gatewayApi } from './apiService';

const BASE = '/talent-service/saved-filters';

const savedFiltersService = {
  async list(pageKey) {
    const response = await gatewayApi.get(BASE, { params: { page_key: pageKey } });
    return response.data;
  },

  async create(payload) {
    const response = await gatewayApi.post(BASE, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await gatewayApi.put(`${BASE}/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    const response = await gatewayApi.delete(`${BASE}/${id}`);
    return response.data;
  },
};

export default savedFiltersService;
